import React, { useState, useEffect } from 'react';
import './Tests.scss'
import { Link } from 'react-router-dom';
import TestsResult from './TestsResult';
import TestsStart from './TestsStart';


const Tests = ({ title, tests }) => {
    const [allTests, setAllTests] = useState([]);
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [testsPerpPage, setTestsPerPage] = useState(16);
    const [btnToggle, setBtnToggle] = useState(false);
    const [isTestsComplate, setIsTestsComplate] = useState(false)
    useEffect(() => {
        try {
            setLoading(true)
            setAllTests(tests)
        } catch (err) {
            setError(err);
        }
        finally {
            setLoading(false);
        }
    }, []);

    //get CurrentPage 
    const indexOfLastTest = currentPage * testsPerpPage;
    const indexOfFirstTest = indexOfLastTest - testsPerpPage;
    const currentTests = allTests.slice(indexOfFirstTest, indexOfLastTest);
    const totalPages = Math.ceil(tests.length / testsPerpPage);

    //next page 
    const next = () => {

        if (!currentPage <= totalPages) {
            setCurrentPage(currentPage - 1)
        }
        setCurrentPage(currentPage + 1)


    }

    //prev hendler
    const prev = () => {

        if (currentPage > 1) {
            setCurrentPage(currentPage - 1)
        }
        else {
            setCurrentPage(1);
        }
    }

    //showsection
    const showsection = () => {
        setBtnToggle(true);
    }
    //show testsresult
    const ResultHandler = (event) => {
        setIsTestsComplate(true);
    }

    if (loading) {
        return <h1>Loading... </h1>
    }
    if (error || !Array.isArray(tests)) {
        return <h3>there are some error with your downloading datas.</h3>
    }

    if (!btnToggle) {
        return <TestsStart showsection={showsection} />
    }
    else if (isTestsComplate) {
        return <TestsResult />
    }
    return (
        <div className='tests'>
            <div className="tests-content container">
                <h3 > <a href="/categories/courses/modules/testenterence"><i className="fas fa-arrow-left"></i></a> {title} </h3>
                <div className='tests-info'>
                    <div className="info-item">Savollar soni : <span> 32</span> ta</div>
                    <div className="info-item">Har bir savol : <span>3.125</span> ball</div>
                    <div className="info-item">O'tish bali : <span> 55 </span> %</div>
                    <div className="info-item">Berilgan vaqt : <span> 1</span> soat</div>
                    <Link to="/categories/courses/modules" className="info-item"> Bekor qilish</Link>
                </div>
                <div className="time-counter">Vaqt: <span>32 : 23</span> </div>
                <form className="tests-form">
                    <div className='tests-list'>

                        {
                            currentTests.map((test, index) => {
                                return <div className="question-box " key={tests.indexOf(test) + 1}>
                                    <p className="question-title">
                                        <span>
                                            {tests.indexOf(test) + 1}.
                                        </span>
                                        {test.title}
                                    </p>
                                    <div className="variants">
                                       
                                        {
                                            test.variants.map((variant, i) => {
                                                return <div className="variant-item  ">
                                                    <input
                                                        type="radio"
                                                        key={i}
                                                        name={tests.indexOf(test) + 1  }
                                                        id={i.toString() + 'variant of' + (tests.indexOf(test)).toString()} />
                                                    <label
                                                        for={i.toString() + 'variant of' + (tests.indexOf(test)).toString()}>{variant.title} </label>
                                                </div>
                                            })
                                        }
                                    </div>
                                </div>
                            })
                        }

                    </div>
                    <div className="tests-submit">
                        {currentPage === totalPages ?
                            <span onClick={e => ResultHandler(e)} className="button button-primary tests-submit-btn">Natijani ko'rish<i className="fas fa-arrow-right"></i></span>
                            :
                            <span onClick={next} className="button button-primary">Next <i className="fas fa-arrow-right"></i></span>}
                        {currentPage > 1 && <a onClick={prev} className="button button-outline-primary"> <i className="fas fa-arrow-left"></i> Orqaga</a>}
                    </div>
                </form>
            </div>

        </div>
    );
}

export default Tests;
